import React, { Suspense, useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "theme";
import Layout from "layout/Layout";
import Login from "component/auth/Login";
import { AppRoutes } from "AppRoutes";
import TermsAndConditions from "components/TermsAndConditions";
import PrivacyPolicy from "components/PrivacyPolicy";
import AboutUs from "components/AboutUs";
import { Box, CircularProgress } from "@mui/material";

const Loading = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <CircularProgress color="primary" fontSize={"medium"} />
    </Box>
  );
};

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Suspense fallback={<Loading />}>
        <Routes>
          <Route
            path="/"
            element={
              token ? (
                <Navigate to="/admin/dashboard" />
              ) : (
                <Navigate to="/admin/login" />
              )
            }
          />
          <Route
            path="/admin/login"
            element={token ? <Navigate to="/admin/dashboard" /> : <Login />}
          />
          <Route path="/terms" element={<TermsAndConditions />} />
          <Route path="/policy" element={<PrivacyPolicy />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route element={<Layout />}>
            {AppRoutes.map((item, idx) => {
              return (
                <Route
                  key={`${item.name}_${idx}`}
                  element={item.element}
                  path={item.path}
                />
              );
            })}
          </Route>
        </Routes>
      </Suspense>
    </ThemeProvider>
  );
}

export default App;
